import React, { useState, useEffect,useMemo,useCallback } from "react";
import { Modal } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import API from "../../services/api";
import NoImage from "../../assets/images/NoImage.png";
import LocationSVG from "../../assets/images/location.svg";
import LanguageSVG from "../../assets/images/langauge.svg";
import { formatDate } from "../../utils/dateFormat";
import { Swiper, SwiperSlide } from "swiper/react";
import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import required modules
import { Pagination, Navigation } from "swiper";
import { roles } from "../../utils/constants";
const languages = {
  "0": "All",
  "1": "Telugu",
  "2": "Tamil",
  "3": "Hindi",
  "4": "Kannada",
  "5": "Malayalam",
  "6": "Marathi",
  "7": "Bengali",
  "8": "Gujarati",
  "9": "Punjabi",
  "10": "Oria",
  "11": "English",
  "13": "Telugu-English"
}
export const FullImage = (props) => {
  const creative = props.creative;
  const l = props.length
  return (
    <>
      <div class="theme">
        {creative?.img_urls ? (
          <div className="h-full w-8/12 z-[1] border-[2px] border-black">
            <img src={creative.img_urls} className="h-full" alt="imgs" />
            </div>
        ) : (
          <img src={NoImage} alt="ad" />
        )}
        <div class="blur">
          {" "}
          {creative?.img_urls ? (
            <img src={creative.image_ursl} alt="ad" />
          ) : (
            <img src={NoImage} alt="ad" />
          )}
        </div>
        <div class="publisher">
          <h6 style={props.colors}>{"Way2news"}</h6>
        </div>
        <p className="location">
          <img src={LanguageSVG} alt="location" />
          {languages[props.language]}
        </p>
        <p class="estimation">
          Spent: <strong>{(props.spent / l).toFixed(2) || 0}</strong>
        </p>
      </div>
      <div class="description">
        {/* <h1>{item.advertisers[0].adv_name || " "}</h1> */}
        <p className="text-xs font-semibold">{props.campaign_name || " "}</p>
        <h5>Ad Format : {creative.sub_type || " "} </h5>
        <h5>Creative : {creative.name}</h5>
      </div>
    </>
  );
};
export const Gallery = (props) => {
  const creative = props.creative;
  return (
    <>
      <div class="theme">
        <div className="w-8/12">
        {creative?.img_urls ? (
          <Swiper
            spaceBetween={50}
            pagination={true}
            navigation={true}
            modules={[Navigation, Pagination]}
            className="mySwiper h-full border-[2px] border-black"
            style={{"--swiper-navigation-size": "16px"}}
          >
            {creative.gallery?.map((item, index) => {
              return <SwiperSlide key={index}><img src={item.image} alt="ads" /></SwiperSlide>;
            })}
          </Swiper>
        ) : (
          <img src={NoImage} alt="ad" />
        )}
        </div>
        <div class="blur">
          {" "}
          {creative?.img_urls ? (
            <img src={creative.image_ursl} alt="ad" />
          ) : (
            <img src={NoImage} alt="ad" />
          )}
        </div>
        <div class="publisher">
          <h6 style={props.colors}>{"Way2news"}</h6>
        </div>
        <p className="location">
          <img src={LanguageSVG} alt="location" />
          {languages[props.language]}
        </p>
        <p class="estimation">
          Spent: <strong>{props.spent || 0}</strong>
        </p>
      </div>
      <div class="description">
        {/* <h1>{item.advertisers[0].adv_name || " "}</h1> */}
        <p className="text-xs font-semibold">{props.campaign_name || " "}</p>
        <h5>Ad Format : {creative.sub_type || " "} </h5>
        <h5>Creative : {creative.name}</h5>
      </div>
    </>
  );
};
export const Fullvideo = (props) => {
  const creative = props.creative;
  return (
    <>
      <div class="theme">
        {creative?.video_urls ? (
          <div className="h-full w-8/12] border-[2px] border-black z-[1]">
          <video className="h-full w-full z-[1]"  alt="ads" controls  muted >
            <source src={creative.video_urls} type="video/mp4" />
          </video>
          </div>
        ) : (
          <img src={NoImage} alt="ad" />
        )}
        <div class="blur">
          {" "}
          {creative?.video_urls ? (
            <img src={creative.image_ursl} alt="ad" />
          ) : (
            <img src={NoImage} alt="ad" />
          )}
        </div>
        <div class="publisher">
          <h6 style={props.colors}>{"Way2news"}</h6>
        </div>
        <p className="location">
          <img src={LanguageSVG} alt="location" />
          {languages[props.language]}
        </p>
        <p class="estimation">
          Spent: <strong>{props.spent?.toFixed(2) || 0}</strong>
        </p>
      </div>
      <div class="description">
        {/* <h1>{item.advertisers[0].adv_name || " "}</h1> */}
        <p className="text-xs font-semibold">{props.campaign_name || " "}</p>
        <h5>Ad Format : {creative.sub_type || " "} </h5>
        <h5>Creative : {creative.name}</h5>
      </div>
    </>
  );
};
export const HalfVideo = (props) => {
  const creative = props.creative;
  return (
    <>
      <div class="theme">
        {creative?.img_urls ? (
          <div className="h-full z-[1] w-8/12 border-[2px] border-black">
            <div className="h-1/3">
             <video className="w-full h-full" alt="ads" controls  muted>
            <source src={creative.video_urls} type="video/mp4" />
          </video>
              </div>
            <img className="h-2/3 w-full" src={creative.img_urls} alt="imgs" />
          </div>
        ) : (
          <img src={NoImage} alt="ad" />
        )}
        <div class="blur">
          {" "}
          {creative?.img_urls ? (
            <img src={creative.image_ursl} alt="ad" />
          ) : (
            <img src={NoImage} alt="ad" />
          )}
        </div>
        <div class="publisher">
          <h6 style={props.colors}>{"Way2news"}</h6>
        </div>
        <p className="location">
          <img src={LanguageSVG} alt="location" />
          {languages[props.language]}
        </p>
        <p class="estimation">
          Spent: <strong>{props.spent || 0}</strong>
        </p>
      </div>
      <div class="description">
        {/* <h1>{item.advertisers[0].adv_name || " "}</h1> */}
        <p className="text-xs font-semibold">{props.campaign_name || " "}</p>
        <h5>Ad Format : {creative.sub_type || " "} </h5>
        <h5>Creative : {creative.name}</h5>
      </div>
    </>
  );
};
export const PromotedImage = (props) => {
  const creative = props.creative;
  const [description, setDescription] = useState("");

  useEffect(() => {
    setDescription(prevDescription => {
      let newDescription = creative.description || "";
      if (newDescription?.search("<<>>") !== -1) {
        let text = newDescription.match(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm);
        let text_inside = newDescription.match(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm);
        text_inside = String(text_inside);
        text_inside = text_inside.substring(6, text_inside.length - 4);
        if (text?.length) {
          newDescription = newDescription.replace(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm, `<span  class="hover:cursor-pointer" style="color:blue; text-decoration:underline">${text_inside}</span>`);
        }
        let newtext = newDescription.match(/<<(https?|ftp):\/\/[^\s$.?#].[^\s]*>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm);
        let linktext = newDescription.match(/>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm);
        const originalString = String(linktext);
        const modifiedString = originalString.substring(2, originalString.length - 4);
        if (newtext?.length) {
          newDescription = newDescription.replace(/<<(https?|ftp):\/\/[^\s$.?#].[^\s]*>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm, `<span  class="hover:cursor-pointer" style="color:blue; text-decoration:underline">${modifiedString}</span>`);
        }
        let phone_text = newDescription.match(
          /(?<=<<(0\d{10}|[6-9]\d{9})>>)[a-zA-Z0-9-!@#$ %^&*(),.?'":{}|]+(?=<<>>)/gi
        );
        if (phone_text) {
          for (let i of phone_text) {
            newDescription = newDescription.replace(
              /<<(0\d{10}|[6-9]\d{9})>>[a-zA-Z0-9-!@#$%^ &*(),.?'":{}|]+<<>>/i,
              `<span style="color:blue">${i}</span>`
            );
          }
        }
      }
      return newDescription;
    })}, [creative.description])
  return (
    <>
      <div class="theme">
        {creative?.img_urls ? (
          <div className="h-full w-8/12 z-[1] border-[2px] border-black">
            <img className="h-2/5 w-full" src={creative.img_urls} alt="ads" />
            <div className="h-3/5 mx-[2px]">
            <p className="my-0 text-[8px] whitespace-normal font-semibold">{creative.head_line}</p>
              <div className="text-[6px] whitespace-normal" dangerouslySetInnerHTML={{ __html: description }} />
            </div>
          </div>
        ) : (
          <img src={NoImage} alt="ad" />
        )}
        <div class="publisher">
          <h6 style={props.colors}>{"Way2news"}</h6>
        </div>
        <p className="location">
          <img src={LanguageSVG} alt="location" />
          {languages[props.language]}
        </p>
        <p class="estimation">
          Spent: <strong>{props.spent || 0}</strong>
        </p>
      </div>
      <div class="description">
        {/* <h1>{item.advertisers[0].adv_name || " "}</h1> */}
        <p className="text-xs font-semibold">{props.campaign_name || " "}</p>
        <h5>Ad Format : {creative.sub_type || " "} </h5>
        <h5>Creative : {creative.name}</h5>
      </div>
    </>
  );
};
export const PromotedGallery = (props) => {
  const creative = props.creative;
  const [description, setDescription] = useState("");

  useEffect(() => {
    setDescription(prevDescription => {
      let newDescription = creative.description || "";
      if (newDescription?.search("<<>>") !== -1) {
        let text = newDescription.match(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm);
        let text_inside = newDescription.match(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm);
        text_inside = String(text_inside);
        text_inside = text_inside.substring(6, text_inside.length - 4);
        if (text?.length) {
          newDescription = newDescription.replace(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm, `<span  class="hover:cursor-pointer" style="color:blue; text-decoration:underline">${text_inside}</span>`);
        }
        let newtext = newDescription.match(/<<(https?|ftp):\/\/[^\s$.?#].[^\s]*>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm);
        let linktext = newDescription.match(/>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm);
        const originalString = String(linktext);
        const modifiedString = originalString.substring(2, originalString.length - 4);
        if (newtext?.length) {
          newDescription = newDescription.replace(/<<(https?|ftp):\/\/[^\s$.?#].[^\s]*>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm, `<span  class="hover:cursor-pointer" style="color:blue; text-decoration:underline">${modifiedString}</span>`);
        }
        let phone_text = newDescription.match(
          /(?<=<<(0\d{10}|[6-9]\d{9})>>)[a-zA-Z0-9-!@#$ %^&*(),.?'":{}|]+(?=<<>>)/gi
        );
        if (phone_text) {
          for (let i of phone_text) {
            newDescription = newDescription.replace(
              /<<(0\d{10}|[6-9]\d{9})>>[a-zA-Z0-9-!@#$%^ &*(),.?'":{}|]+<<>>/i,
              `<span style="color:blue">${i}</span>`
            );
          }
        }
      }
      return newDescription;
    })}, [creative.description])
  return (
    <>
      <div class="theme">
        {creative?.img_urls ? (
          <div className="h-full w-8/12 z-[1] border-[2px] border-black">
            <div className="h-2/5">
            <Swiper
              spaceBetween={50}
              pagination={true}
              navigation={true}
              style={{"--swiper-navigation-size": "16px"}}
              modules={[Navigation, Pagination]}
              className="mySwiper h-full"
            >
              {creative.gallery?.map((item, index) => {
                return<SwiperSlide key={index}><img src={item.image} alt="ads" /></SwiperSlide> ;
              })}
            </Swiper>
            </div>
            <div className="h-3/5 mx-[2px]">
              <p className="my-0 text-[8px] whitespace-normal font-semibold">{creative.head_line}</p>
              <div className="text-[6px] whitespace-normal" dangerouslySetInnerHTML={{ __html: description }} />
            </div>
          </div>
        ) : (
          <img src={NoImage} alt="ad" />
        )}
        <div class="publisher">
          <h6 style={props.colors}>{"Way2news"}</h6>
        </div>
        <p className="location">
          <img src={LanguageSVG} alt="location" />
          {languages[props.language]}
        </p>
        <p class="estimation">
          Spent: <strong>{props.spent || 0}</strong>
        </p>
      </div>
      <div class="description">
        {/* <h1>{item.advertisers[0].adv_name || " "}</h1> */}
        <p className="text-xs font-semibold">{props.campaign_name || " "}</p>
        <h5>Ad Format : {creative.sub_type || " "} </h5>
        <h5>Creative : {creative.name}</h5>
      </div>
    </>
  );
};

export const PromotedVideo = (props) => {
  const creative = props.creative;
  const [description, setDescription] = useState("");

  useEffect(() => {
    setDescription(prevDescription => {
      let newDescription = creative.description || "";
      if (newDescription?.search("<<>>") !== -1) {
        let text = newDescription.match(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm);
        let text_inside = newDescription.match(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm);
        text_inside = String(text_inside);
        text_inside = text_inside.substring(6, text_inside.length - 4);
        if (text?.length) {
          newDescription = newDescription.replace(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm, `<span  class="hover:cursor-pointer" style="color:blue; text-decoration:underline">${text_inside}</span>`);
        }
        let newtext = newDescription.match(/<<(https?|ftp):\/\/[^\s$.?#].[^\s]*>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm);
        let linktext = newDescription.match(/>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm);
        const originalString = String(linktext);
        const modifiedString = originalString.substring(2, originalString.length - 4);
        if (newtext?.length) {
          newDescription = newDescription.replace(/<<(https?|ftp):\/\/[^\s$.?#].[^\s]*>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm, `<span  class="hover:cursor-pointer" style="color:blue; text-decoration:underline">${modifiedString}</span>`);
        }
        let phone_text = newDescription.match(
          /(?<=<<(0\d{10}|[6-9]\d{9})>>)[a-zA-Z0-9-!@#$ %^&*(),.?'":{}|]+(?=<<>>)/gi
        );
        if (phone_text) {
          for (let i of phone_text) {
            newDescription = newDescription.replace(
              /<<(0\d{10}|[6-9]\d{9})>>[a-zA-Z0-9-!@#$%^ &*(),.?'":{}|]+<<>>/i,
              `<span style="color:blue">${i}</span>`
            );
          }
        }
      }
      return newDescription;
    })}, [creative.description])
  return (
    <>
      <div class="theme">
        {creative?.img_urls ? (
          <div className="h-full w-8/12 z-[1] border-[2px] border-black">
            <video className="h-2/5 w-full" alt="ads" controls  muted>
            <source src={creative.video_urls} type="video/mp4" />
            </video>
            <div className="h-3/5 mx-[2px] w-full">
            <p className="my-0 text-[8px] whitespace-normal font-semibold">{creative.head_line}</p>
              <div className="text-[6px] whitespace-normal" dangerouslySetInnerHTML={{ __html: description }} />
            </div>
          </div>
        ) : (
          <img src={NoImage} alt="ad" />
        )}
        <div class="publisher">
          <h6 style={props.colors}>{"Way2news"}</h6>
        </div>
        <p className="location">
          <img src={LanguageSVG} alt="location" />
          {languages[props.language]}
        </p>
        <p class="estimation">
          Spent: <strong>{props.spent || 0}</strong>
        </p>
      </div>
      <div class="description">
        {/* <h1>{item.advertisers[0].adv_name || " "}</h1> */}
        <p className="text-xs font-semibold">{props.campaign_name || " "}</p>
        <h5>Ad Format : {creative.sub_type || " "} </h5>
        <h5>Creative : {creative.name}</h5>
      </div>
    </>
  );
};

export const WebView = (props) => {
  const creative = props.creative;
  return (
    <>
      <div class="theme">
        {creative?.img_urls ? (
          <div className="h-full w-8/12 z-[1] border-[2px] border-black">
            <iframe className='h-full w-full' src={creative.img_urls} alt="webviewad" title='webviewad'></iframe>
          </div>
        ) : (
          <img src={NoImage} alt="ad" />
        )}
        <div class="publisher">
          <h6 style={props.colors}>{"Way2news"}</h6>
        </div>
        <p className="location">
          <img src={LanguageSVG} alt="location" />
          {languages[props.language]}
        </p>
        <p class="estimation">
          Spent: <strong>{props.spent || 0}</strong>
        </p>
      </div>
      <div class="description">
        <p className="text-xs font-semibold">{props.campaign_name || " "}</p>
        <h5>Ad Format : {creative.sub_type || " "} </h5>
        <h5>Creative : {creative.name}</h5>
      </div>
      </>
  )
};

export const CommentAd = (props) => {
  const creative = props.creative;
  return (
    <>
      <div class="theme">
        {creative?.img_urls ? (
          <div className="border-[2px] border-black w-8/12 h-full">
            <img src={creative.img_urls} className="h-auto"  alt="imgs" />
            </div>
        ) : (
          <img src={NoImage} alt="ad" />
        )}
        <div class="blur">
          {" "}
          {creative?.img_urls ? (
            <img src={creative.image_ursl} alt="ad" />
          ) : (
            <img src={NoImage} alt="ad" />
          )}
        </div>
        <div class="publisher">
          <h6 style={props.colors}>{"Way2news"}</h6>
        </div>
        <p className="location">
          <img src={LanguageSVG} alt="location" />
          {languages[props.language]}
        </p>
        <p class="estimation">
          Spent: <strong>{props.spent || 0}</strong>
        </p>
      </div>
      <div class="description">
        {/* <h1>{item.advertisers[0].adv_name || " "}</h1> */}
        <p className="text-xs font-semibold">{props.campaign_name || " "}</p>
        <h5>Ad Format : {creative.sub_type || " "} </h5>
        <h5>Creative : {creative.name}</h5>
      </div>
    </>
  );
};

export const FullVideoOrGif = (props) =>{
  const creative = props.creative;
  const type = creative.img_urls.split('.').pop();
  return (
    <>
      <div class="theme">
        <div className="h-full w-8/12 z-[1] border-[2px] border-black">
        {type === 'gif' || type === 'jpg' || type === 'png' || type === 'jpeg'? (
          <img src={creative.img_urls} className="h-full" alt="gif" />
        ) : (
          <video className="h-full w-full" alt="ads" controls  muted>
          <source src={creative.img_urls} type="video/mp4" />
          </video>
        )}
        </div>
        <div class="publisher">
          <h6 style={props.colors}>{"Way2news"}</h6>
        </div>
        <p className="location">
          <img src={LanguageSVG} alt="location" />
          {languages[props.language]}
        </p>
        <p class="estimation">
          Spent: <strong>{props.spent || 0}</strong>
        </p>
      </div>
      <div class="description">
        <p className="text-xs font-semibold">{props.campaign_name || " "}</p>
        <h5>Ad Format : {creative.sub_type || " "} </h5>
        <h5>Creative : {creative.name}</h5>
      </div>
    </>
  );
}

export const RectangleClassified = (props) =>{
    const creative = props.creative;
  return(
    <>
      <div className="theme">
          <div className="h-full w-8/12 z-[1] border-[2px] border-black">

      <div className="h-full grid grid-rows-5 gap-2 p-2">
              <div className="grid-rows-1 bg-green-200 rounded-md" style={{background: 'linear-gradient(135deg, #F9F2E8, #FCCFBA, #F9F2E8)'}}>
                <div className="flex flex-col justify-between">
                <div className="flex justify-start gap-2  p-2 items-start">
                  {creative.img_urls ? <img src={creative.img_urls} className="w-[20px] h-[18px] object-cover rounded-lg"  alt="titleimage" />: null}
                  <div>
                    <h3 className="!text-[8px] font-bold">{creative.headline || creative.head_line}</h3>
                    <p className="text-[6px] mb-0 !h-5 overflow-hidden">{creative.description}</p>
                  </div>
                </div>
                <div className="flex items-center justify-between p-2 border-t-[1px] border-gray-300">
                  <div className="flex justify-center gap-2  items-start ">
                {(creative.logo_urls || creative.gallery?.image )? <img src={creative.logo_urls || creative.gallery?.image} className="w-2 h-2 rounded-full"  alt="logo" />: null}
                  <div >
                    <h6 className="text-[8px] mb-0">{creative.brand_name || creative.gallery?.brand_name}</h6>
                    <p className=" mb-0 text-[6px]">{creative.caption || creative.gallery?.caption}</p>
                  </div>
                  </div>
                {creative.button_enabled ? <button style={{ backgroundColor: creative.btn_text_bgclr, color: creative.btn_text_clr }} className="px-1 py-1 bg-green-500 rounded-md text-xs"><span className="flex gap-1 items-center">{(creative.btn_type === '0' || creative.gallery?.btn_type === '0') ? '': <SlIcon  name={(creative.btn_type === '1' || creative.gallery?.btn_type === '1')? 'telephone' : 'whatsapp'}></SlIcon>}{creative.button_text}</span></button> : null}
                </div>
                </div> 
              </div>
              {Array.from({ length: 4 }).map((_, index) => (
                <div key={index} className="grid-rows-1 bg-slate-100 rounded-md"></div>
              ))}
                  <div class="publisher">
              <h6 style={props.colors}>{"Way2news"}</h6>
            </div>
            <p className="location">
              <img src={LanguageSVG} alt="location" />
              {languages[props.language]}
            </p>
            <p class="estimation">
              Spent: <strong>{props.spent || 0}</strong>
            </p>
            </div>
            </div>
            </div>
             <div class="description">
        <p className="text-xs font-semibold">{props.campaign_name || " "}</p>
        <h5>Ad Format : {creative.sub_type || " "} </h5>
        <h5>Creative : {creative.name}</h5>
      </div>
    </>
  )
}

function BirdViewData(props) {
  let {fetchW2n, fetchAllNews, fetchW2nCampaign_type} = props
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [w2nData, setW2NData] = useState({});
  const [newspaperData, setNewsPaperData] = useState([]);
  const [imgSrc, setImgSrc] = useState("");
  const [see, setSee] = useState(false);
  const [locations,setLocations] = useState([]);
 
  const fetchAds = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/sales_dashboard/birdViewData",
        method: "POST",
        responseType: "json",
        data: {
          brand_id: props.brand,
          date: props.date,
          newspaper_name: props.newspaper !== "All" ? props.newspaper : null
        },
      });
      if (res.code === 200) {
        setData(res.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };
  const fetchW2NAds = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/market/get_month_creatives",
        method: "POST",
        responseType: "json",
        data: {
          brand_id: props.brand,
          date: props.date,
          lang_id: props.from === "market" ? props.language : 0,
          sales_id: props.salesPerson_id === -1 ? undefined : props.salesPerson_id,
          fetchW2nCampaign_type: fetchW2nCampaign_type ? fetchW2nCampaign_type : undefined
        },
      });
      if (res.code === 200) {
        setW2NData(res.data ?? {});
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    if (
      props.brand !== null &&
      props.date.startDate !== null &&
      props.date.endDate !== null &&
      fetchAllNews
    ) {
      fetchAds();
    }
  }, [props.brand, props.date, props.salesPerson_id]);
  const fetchNewsPapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setNewsPaperData([...res.data]);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const loadLocations = useCallback(async () => {
    try {
       
      const response = await API({
        // url: `/birdview/birdviewLocations`,
        url: `/birdview/newspaper_locations`,
        method: "POST",
        responseType: "json",
    });
    if (response?.code === 200) {
        setLocations([...response?.data?.result]);
    } else {
        console.error(response.message)
    }
    } catch (error) {
      console.error(error);
    }   
},[]);
  const locationObject = useMemo(() => {
    const obj = {};
    locations.forEach((location) => {
        obj[location.value] = location.label;
    });
    return obj;},[locations])
    useEffect(()=>{
      loadLocations();
    },[])
  
  useEffect(() => {
    fetchNewsPapers();
    if(fetchW2n)
      fetchW2NAds();
  }, [props.brand, props.date, props.salesPerson_id]);

  const getColors = (brand) => {
    const brandLookup = newspaperData.filter((np) => np.name === brand);
    return {
      backgroundColor: brandLookup[0]?.background_color,
      color: brandLookup[0]?.color,
    };
  };
  return (
    <>
      <div
        className={`d-flex flex-wrap overflow-y-auto ${
          props.from !== "market" ? "dashBoardBird" : "marketDashboardBird"
        } border-b-2 border-gray-500`}
      >
        {data?.length && !loader ? (
          <div class="birdviewWrapper m-0 border-b-2">
            <ul class="birdview">
              {data.map((item, index) => {
                return (
                  <li>
                    <div class="theme">
                      {item?.image_url ? (
                        <img src={item.image_url} alt="ads" />
                      ) : (
                        <img src={NoImage} alt="ad" />
                      )}
                      <div class="blur">
                        {" "}
                        {item?.image_url ? (
                          <img src={item.image_url} alt="ad" />
                        ) : (
                          <img src={NoImage} alt="ad" />
                        )}
                      </div>
                      <div class="publisher">
                        {item?.newspaper_name ? (
                          <h6 style={getColors(item?.newspaper_name)}>
                            {item.newspaper_name}
                          </h6>
                        ) : null}
                      </div>
                      {item.location  ? <p className="location">
                        <img
                          src={LocationSVG}
                          alt="location_name"
                          title={locationObject[item.location]}
                        />
                        {locationObject[item.location]}
                      </p> : null}
                      <p class="estimation">
                        Est Val: <strong>{item.estimated_value || 0}</strong>
                      </p>
                      {/* Selcter CheckBox */}
                      {/* <div class="radioGroup">
                                                <input type="checkbox" id={item.id} checked={selectedRecords.includes(item.id)}
                                                    onChange={() => toggleCheckbox(item.id)} />
                                                <label for={item.id}></label>
                                            </div> */}
                    {item.image_url ? (<Button className="previewBtn" variant="neutral"
                                onClick={() => { setImgSrc(item.image_url); setSee(true) }}
                            >
                                Preview
                            </Button>) : null}
                     {localStorage.getItem('role') === roles.salesperson ? <button onClick={()=>{
              props.setReportId(item.id);
              props.setImageUrl(item.image_url)
              props.setShowReport(true)
             }} className="border-[1px] !z-10 !border-red-500 bg-white text-xs font-bold text-red-500 px-2 py-1 rounded-md absolute right-2 top-2 flex gap-1 items-center hover:text-white hover:!bg-red-500"><sl-icon library="lucide" name="alert-triangle"></sl-icon><span>Report</span></button> : null }
                    </div>
                    <div class="description">
                      {item?.page_no ? (
                        <p>
                          Page {item.page_no} : {formatDate(item.date)}
                        </p>
                      ) : (
                        <p>Page - : {formatDate(item.date)}</p>
                      )}
                      {/* <h1>{item.advertisers[0].adv_name || " "}</h1> */}
                      <h1>{item.campaign_name || " "}</h1>
                      <h5>Edition : {item.edition || " "}</h5>
                      {/* <h5>Page Name : {item.edition || " "}</h5> */}
                      <h5>Ad Format : {item.ad_format || " "} </h5>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        ) : !data?.length && !loader ? null : (
          <div class="d-flex justify-content-center mx-auto">
            <div class="spinner-border" role="status">
              {/* <span class="sr-only">Loading...</span> */}
            </div>
          </div>
        )}
      </div>
      <div
        className={`d-flex flex-wrap overflow-y-auto ${
          props.from !== "market" ? "dashBoardBird" : "marketDashboardBird"
        }`}
      >
        {Object.keys(w2nData)?.length ? (
          <div class="birdviewWrapper m-0">
            <ul class="birdview">
              {Object.keys(w2nData).map((key, index) => {
                const item = w2nData[key];
                return (
                  <>
                    {item.w2n_campaign_details?.map((campaign, index) => {
                      return (
                        <>
                          {/* <Swiper
                            // spaceBetween={50}
                            pagination={true}
                            navigation={true}
                            modules={[Navigation, Pagination]}
                            className="mySwiper h-full"
                          > */}
                            {campaign?.creatives?.map((creative, index) => {
                              return (
                                <>
                                  <li>
                                    {creative?.sub_type === "full_image" && (
                                      <FullImage
                                        creative={creative}
                                        spent={campaign.spent}
                                        language={campaign.lang_id}
                                        campaign_name={campaign.campaign_name}
                                        length={campaign?.creatives?.length || 1}
                                        colors={getColors("Way2news")}
                                      />
                                    )}
                                    {creative?.sub_type === "gallery" && (
                                      <Gallery
                                        creative={creative}
                                        spent={campaign.spent}
                                        language={campaign.lang_id}
                                        campaign_name={campaign.campaign_name}
                                        colors={getColors("Way2news")}
                                      />
                                    )}
                                    {creative?.sub_type === "full_video" && (
                                      <Fullvideo
                                        creative={creative}
                                        language={campaign.lang_id}
                                        spent={campaign.spent}
                                        campaign_name={campaign.campaign_name}
                                        colors={getColors("Way2news")}
                                      />
                                    )}
                                    {creative?.sub_type === "half_video" && (
                                      <HalfVideo
                                        creative={creative}
                                        language={campaign.lang_id}
                                        spent={campaign.spent}
                                        campaign_name={campaign.campaign_name}
                                        colors={getColors("Way2news")}
                                      />
                                    )}
                                    {creative?.sub_type ===
                                      "promoted_image_story" && (
                                      <PromotedImage
                                        creative={creative}
                                        language={campaign.lang_id}
                                        spent={campaign.spent}
                                        campaign_name={campaign.campaign_name}
                                        colors={getColors("Way2news")}
                                      />
                                    )}
                                    {creative?.sub_type === "promoted_video_story" && (
                                      <PromotedVideo
                                        creative={creative}
                                        language={campaign.lang_id}
                                        spent={campaign.spent}
                                        campaign_name={campaign.campaign_name}
                                        colors={getColors("Way2news")}
                                      />
                                    )}
                                    {creative?.sub_type === "promoted_gallery" && (
                                      <PromotedGallery
                                        creative={creative}
                                        language={campaign.lang_id}
                                        spent={campaign.spent}
                                        campaign_name={campaign.campaign_name}
                                        colors={getColors("Way2news")}
                                      />
                                    )}
                                    {creative?.sub_type === "webviewad" && (
                                      <WebView
                                        creative={creative}
                                        language={campaign.lang_id}
                                        spent={campaign.spent}
                                        campaign_name={campaign.campaign_name}
                                        colors={getColors("Way2news")}
                                      />
                                    )}
                                    {creative?.sub_type === "commentad" && (
                                      <CommentAd
                                        creative={creative}
                                        language={campaign.lang_id}
                                        spent={campaign.spent}
                                        campaign_name={campaign.campaign_name}
                                        colors={getColors("Way2news")}
                                      />
                                    )}
                                    {creative?.sub_type === "fullvideo_or_gif" && (
                                      <FullVideoOrGif
                                        creative={creative}
                                        language={campaign.lang_id}
                                        spent={campaign.spent}
                                        campaign_name={campaign.campaign_name}
                                        colors={getColors("Way2news")}
                                      />
                                    )}
                                    {
                                      creative?.sub_type === "rectangle_classified" && (
                                      <RectangleClassified
                                        creative={creative}
                                        language={campaign.lang_id}
                                        spent={campaign.spent}
                                        campaign_name={campaign.campaign_name}
                                        colors={getColors("Way2news")}
                                      />
                                    )
                                    }
                                  </li>
                                </>
                              );
                            })}
                          {/* </Swiper> */}
                        </>
                      );
                    })}
                  </>
                );
              })}
            </ul>
          </div>
        ) : null}
      </div>
      <Modal className="birdview-image-preview" show={see} onHide={() => setSee(false)}>
                <Modal.Header closeButton>Image Preview
                </Modal.Header>
                <Modal.Body>
                    <img src={imgSrc} alt="" />
                </Modal.Body>
            </Modal >

    
    </>
  );
}

export default BirdViewData;
